import { Component, Input } from "@angular/core";
import { LoadingController } from "@ionic/angular";
import { GatewayService } from "projects/core/src/lib/core/GatewayService";
import { MessageService } from "projects/core/src/lib/core/MessageService";

@Component({
  selector: 'component-incomplete-form',
  templateUrl: './incomplete-form.component.html',
  styleUrls: ['./incomplete-form.component.scss'],
})
export class IncompleteFormComponent {

  constructor(
    private loadingController: LoadingController
  ) { }

  @Input() users = [];

  formValue: any
  gatewayService = new GatewayService()
  listUsersIncompleteForm = []
  showButtonNewForm = false

  async ngOnInit() {
    this.getListUsersIncomplete() 
  }

  async getListUsersIncomplete() {
    const loading = await this.showLoading()
    try {
      const result = await this.gatewayService.requestGet(`/api/partners/wise/form/incomplete`)

      if (result.status == 200) {
        if (result.data.length > 0) {
          this.listUsersIncompleteForm = result.data
        } else {
          this.showButtonNewForm = true
          this.clickNewForm()
        }
      }
    } catch(e: any) {
      alert(e.message)
    }
    loading.dismiss()
  }

  async showLoading() {
    const loading = await this.loadingController.create({
      duration: 0,
      mode: 'ios',
      keyboardClose: true
    });
    await loading.present();
    return loading
  }

  async initNewForm() {
    try {
      const result = await this.gatewayService.requestGet(`/api/partners/wise/form/init`)

      if (result.status == 200) {
        this.showButtonNewForm = false
        this.redirectToQuestion(result.data)
      }
    } catch(e: any) {
      alert(e.message)
    }
  }

  clickNewForm() {
    this.initNewForm()
  }

  redirectToQuestion(client: any) {
    MessageService.sendMessage(MessageService.KEY_CLIENT_PROSPECT_SELECT_USER_INCOMPLETE_FORM, client)
  }
}
